const html = require('choo/html')
const { Button, Input, Wave } = require('./components/elements.js')

const SoundLibrary = require('./components/sound-library.js')
const SampleBoard = require('./components/sample-board.js')
const Recording = require('./components/recording.js')
const LoadingMessage = require('./components/loading.js')
const Logo = require('./components/logo.js')
const Tutorial = require('./components/tutorial.js')
const SharingDialog = require('./components/sharing-dialog.js')

const playSample = require('./store/utility/playSample.js')
const stopLoop = require('./store/utility/stopLoop.js')

function SamplerApp(state, emit) {
  if (!state.samples) {
    emit('loadlibrary')
    return html`
      <body class="${state.theme}"> 
        <div id="app">
          ${Logo()}
          ${LoadingMessage(state, emit)}
        </div>
      </body>
    `
  }

  function onKeyDown(e) {
    console.log("state.acitveButtons", state.activeButtons)
    console.log("onKeyDown", e)
    if (state.typing) {
      // don't play audio
      return
    }
    // return if the key is not spacebar
    if (e.key !== ' ') {
      return
    }
    if (!state.keyIsDown) {
      emit('play-next-sound')
      
    }
  }

  function onKeyUp(e) {
    if (state.typing) return
    const key = e.key.toLowerCase()

    // return if the key is not spacebar
    if (e.key !== ' ') {
      return
    }
    state.keyIsDown = false

    const sampleIndex = state.boardLayout.findIndex(s => s.key === key)
    if (sampleIndex !== -1) {
      const sample = state.samples.find(
        s => s.id === state.sampleBoard[sampleIndex]
      )
      stopLoop(sample)
      emit('releasebutton', sampleIndex)
    }
  }
  function PressSpaceButton(state, emit) {
    return html`
    <div
    style="display:inline-block; width:25%; height:100%; margin-right:37.5%; margin-left:37.5%; "
    >
    ${Button(
      {
        color: 'yellow',
        onMouseDown: () => onKeyDown({ key: ' ' })
      },
      html`
        <span class="description" id="press-space">
          PRESS SPACE TO PLAY
        </span>
      `
    )}
  </div>`
  }
  // Mostly prevents zooming on iPad
  function onTouchStart(e) {
    e.preventDefault()
    e.target.dispatchEvent(new Event('mousedown'))
  }
  function onTouchEnd(e) {
    e.preventDefault()
    e.target.dispatchEvent(new Event('click'))
    e.target.dispatchEvent(new Event('mouseup'))
  }

  let layout = html`
    ${SoundLibrary(state, emit)}
    ${SampleBoard(state, emit)}
    ${Recording(state, emit)}
  `

  if (state.isSoundLibraryOpen) {
    layout = html`
      <div id="customizing" class="row">
        ${SoundLibrary(state, emit)}
        ${SampleBoard(state, emit)}
      </div>
      ${Recording(state, emit)}
    `
  } else if (state.isRecordingOpen) {
    layout = html`
      ${SoundLibrary(state, emit)}
      <div id="customizing" class="row">
        ${SampleBoard(state, emit)}
        ${Recording(state, emit)}
      </div>
    `
  }

  return html`
    <body
      class="${state.theme}"
      onkeydown=${onKeyDown}
      onkeyup=${onKeyUp}
      ontouchstart=${onTouchStart}
      ontouchend=${onTouchEnd}
      ondragstart=${(e) => emit('dragstart', e)}
      ondragend=${(e) => emit('dragend', e)}
      ondragover=${(e) => emit('dragover', e)}
      ondragenter=${(e) => emit('dragenter', e)}
      ondragleave=${(e) => emit('dragleave', e)}
      ondrop=${(e) => emit('drop', e)}
      >
      <div id="app" onmouseup=${() => onKeyUp({key:' '})}>
        ${Logo()}
        ${layout}
        ${Tutorial(state, emit)}
        <div class="start-tutorial">
          ${Button({ onClick: () => emit('starttutorial') }, 'How it works?')}
        </div>
      </div>
    </body>
  `
}



module.exports = SamplerApp
